export enum ClevertapEvents {
  // The sanity_funnel_* events (email captured / completed) are fired
  // server-side by ffh-public-api's funnel endpoints, keyed on the
  // deterministic profileId derived from the captured email.
  checkoutStarted = 'checkout_started'
}

// Canonical property names per the CleverTap Phase 1 Engineering Reference
// (v2), sections 4.2 and 5. CleverTap filters are case-sensitive, so values
// must match the spec exactly (e.g. sufSource is 'GYTR' | 'MLR').
export enum ClevertapEventProperties {
  intendedTier = 'intended_tier',
  membershipTier = 'membership_tier',
  sufSource = 'sanity_suf_source',
  gwTiming = 'sanity_gw_timing',
  // sanity_funnel_completed_date is stamped server-side by ffh-public-api
  // (browser clocks aren't trusted), so it has no client-side constant.
  gytrScore = 'sanity_gytr_score',
  gytrScorePotential = 'sanity_gytr_score_potential',
  gytrTransferUplift = 'sanity_gytr_transfer_uplift',
  gytrCaptainMatchAi = 'sanity_gytr_captain_match_ai',
  gytrCaptainCost = 'sanity_gytr_captain_cost'
}
